module.exports = __webpack_public_path__ + "img/img_dmain6.0b81406f.jpg";